import { Skeleton } from "@aqar-app/react-ui";
import { usePath } from "../../../../contexts/path/path";
import useStats from "../../../new-resolver/StatsTable";
import css from "./.module.scss";

export const STATS_TITLE_CATEGORY_MAP = {
  1: "متوسط إيجار شقة 3 غرف",
  2: "متوسط سعر المتر المربع",
  3: "متوسط سعر فيلا ٣٥٠ م²",
};

function StatsTable() {
  const { district, category } = usePath();
  const [statsList, loading] = useStats();
  return (
    <div className={css.statsTable}>
      <div className={css.statsHeader}>
        <div>{STATS_TITLE_CATEGORY_MAP[category.id]}</div>
        <div>{`حي ${district.name}`}</div>
      </div>

      {loading ? (
        <>
          <div className={css.holder} />
          <Skeleton className={css.holder} />
          <div className={css.holder} />
          <Skeleton className={css.holder} />
          <div className={css.holder} />
          <Skeleton className={css.holder} />
          <div className={css.holder} />
          <Skeleton className={css.holder} />
          <div className={css.holder} />
        </>
      ) : null}
      {!!statsList?.length && (
        <ul className={css.statsList}>
          {statsList.map((data) => (
            <li className={css.statsItem} key={data.key}>
              <div className={css.label}>{data.key}</div>
              <div
                className={css.value}
              >{`${data.value.toLocaleString()} ريال`}</div>
            </li>
          ))}
        </ul>
      )}
      {!statsList?.length &&
        !loading &&
        !(<p className={css.emptyStats}>لا يوجد احصائيات حالياً لهذا الحي.</p>)}
    </div>
  );
}

export default StatsTable;
